/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Clarity_TitleInputs */

const en_admin_settings_groups_clarity_title = /** @type {(inputs: Admin_Settings_Groups_Clarity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Clarity`)
};

/**
* | output |
* | --- |
* | "Microsoft Clarity" |
*
* @param {Admin_Settings_Groups_Clarity_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_clarity_title = /** @type {((inputs?: Admin_Settings_Groups_Clarity_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Clarity_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_clarity_title(inputs)
});
export { admin_settings_groups_clarity_title as "admin.settings.groups.clarity.title" }